import { createSelector } from 'reselect'

import { RootState } from '../types'

const selectState = (state: RootState) => state.location

export const getCurrentLocationPath = createSelector(selectState, state => state.currentLocationPath)
